<template>
  <div>
      <topNav :userLog="this.authUser.name"/>
      <div id="layoutSidenav">
          <layoutSidenav_nav :pos="user.position"/>

          <layoutSidenav_content>
              <template v-slot:Main>
                  <main>
                     <router-view></router-view>
                  </main>
              </template>

              <template v-slot:Footer>
                  <app-footer></app-footer>
              </template>
          </layoutSidenav_content>
      </div>
  </div>
</template>

<script>
  import layoutSidenav_nav from '../app-layout/_sideNav/layoutSidenav_nav';
  import layoutSidenav_content from '../app-layout/_sideNav/layoutSidenav_content';
  import TopNav from '../app-layout/TopNav';
  import AppFooter from '../app-layout/Footer';
  import {formMixins} from '../../mixins/formMixins';

  export default {
    name: 'LayoutSideNav',
    mixins:[formMixins],
    components: {
      layoutSidenav_nav,
      layoutSidenav_content,
      TopNav,
      AppFooter,
    },

    data(){
      return{
        user:{
          position:'Avenger'
        }
      }
    },

    mounted() {
      // Toggle the side navigation
      $("#sidebarToggle").on("click", function(e) {
        e.preventDefault();
        $("body").toggleClass("sb-sidenav-toggled");
      });
    }
  };
</script>

<style scoped>

</style>
